<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="logo_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img src="../../assets/img_public/logo.webp" @click="goIndex" />
				</div>
				<div class="block_1_main">
					<div class="left">
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="title"
						></div>
						<div v-if="navList.length > 0" class="list_box">
							<div
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								v-for="(value, index) in navList"
								:key="index"
								v-if="value.route != 'Index'"
								class="list_el"
							>
								<div v-if="value.route == 'Product'">
									<div class="tit" @click="oneNavClick(value)">{{ value.title }}</div>
									<!-- <div class="txt" @click="oneNavClick(value)">Solution</div>
									<div class="txt" @click="oneNavClick(value)">Product Category</div> -->
								</div>
								<div v-else>
									<div class="tit" @click="oneNavClick(value)">{{ value.title }}</div>
									<template v-if="value.children">
										<div v-for="(value2, index2) in value.children" :key="index2" class="txt" @click="oneNavClick(value2, true)">{{ value2.title }}</div>
									</template>
								</div>
							</div>
						</div>
						<div
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="200"
							data-aos-offset="0"
							data-aos-once="true"
							class="text"
						>
							<van-icon name="location" color="#999999" size="14" class="icon" style="top:2px;" />
							<span>No.8 Central Road, Doudian Town, Fangshan District, Beijing 102433, China</span>
						</div>
						<div
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="200"
							data-aos-offset="0"
							data-aos-once="true"
							class="text"
						>
							<van-icon name="location" color="#999999" size="14" class="icon" style="top:2px;" />
							<span style="font-size: 14px;">5900 Windward Pkwy. Alpharetta, GA 30005 USA<span style="font-size: 12px;"></span></span>
						</div>
					</div>
					<div class="right">
						<div
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							class="code_box"
						>
							<img src="../../assets/img_public/footer/qrcode.webp" />
							<!-- <div class="tit">关注宝瑞源</div> -->
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="block_2"
			>
				<div class="link_box">
					<div class="tit">Associated Website: </div>
					<div class="link_el">
						<a href="https://cordx.com/">Cordx Union</a>
					</div>
					<div class="link_el">
						<a href="https://coretests.com/">Core tests</a>
					</div>
					<div class="link_el">
						<a href="https://bonore.com/">Bono Plastics</a>
					</div>
				</div>
				<!-- <div class="text">
					<a href="https://beian.miit.gov.cn/">京ICP备17072452号-1</a>&ensp;&ensp;互联网药品信息服务资格证明书编号：(京)-非经营性-2015-0020
				</div> -->
			</div>
			<!--块2-->
		</div>
	</div>
</template>

<script>
	export default {
		components: {
			//
		},
		data() {
			return {
				navList: [],
				lang: sessionStorage.getItem('lang')
			}
		},
		created() {
			let that = this;
			if(sessionStorage.getItem('navList')) {
				that.navList = JSON.parse(sessionStorage.getItem('navList'));
			}
		},
		mounted() {
			let that = this;
		},
		watch: {
			//
		},
		methods: {
			//一级导航点击
			oneNavClick(value, value2) {
				let that = this;
				if(that.$route.path != value.url) {
					if(value2) {
						if(that.$route.name === value.route) {
							that.$router.push({ path: value.url, });
							window.location.reload();
						}else {
							if(that.$route.path != value.url) {
								that.$router.push({ path: value.url, });
								setTimeout(() => {
									window.location.reload();
								}, 300);
							}
						}
					}else {
						that.$router.push({ path: value.url });
						setTimeout(() => {
							window.location.reload();
						}, 300);
					}
				}else {
					window.location.reload();
				}
			},
			//点击首页
			goIndex() {
				if (this.$route.path != '/') {
					this.$router.push({
						path: '/'
					});
				} else {
					window.location.reload();
				}
			},
		}
	}
</script>

<style lang="less" scoped>
.main_box {
	color: #333333;
	//块2
	.block_2{
		padding: 20px 16px;
		background-color: #eeeeee;
		.text{
			padding-top: 18px;
			font-size: 12px;
			text-align: center;
			a{
				font-size: 12px;
				color: #333333;
			}
		}
		.link_box{
			.link_el{
				display: inline-block;
				margin: 4px 10px 0 0;
				a{
					font-size: 12px;
					color: #333333;
				}
			}
			.tit{
				font-size: 14px;
				font-weight: bold;
			}
		}
	}
	//块1
	.block_1{
		padding: 50px 16px 20px 16px;
		background-color: #f6f6f6;
		.block_1_main{
			display: flex;
			.right{
				width: auto;
				.code_box{
					.tit{
						padding-top: 5px;
						text-align: center;
						font-size: 10px;
					}
					img{
						width: 75px;
					}
				}
			}
			.left{
				flex: 1;
				.text{
					display: flex;
					padding-bottom: 4px;
					.icon{
						width: auto;
					}
					span{
						flex: 1;
						display: inline-block;
						padding-left: 6px;
						font-size: 12px;
					}
				}
				.list_box{
					padding-bottom: 15px;
					.list_el{
						padding: 2px 0;
						.txt{
							display: inline-block;
							margin-right: 10px;
							font-size: 12px;
						}
						.tit{
							display: inline-block;
							margin-right: 15px;
							font-size: 12px;
							font-weight: bold;
						}
					}
				}
				.title{
					padding: 8px 0 10px 0;
					font-weight: bold;
				}
			}
		}
		.logo_box{
			img{
				width: 130px;
			}
		}
	}
}
</style>